/*
 * @Author: ITDLCL
 * @Date: 2025-01-08 14:00:39
 * @LastEditors: ITDLCL
 * @Description: 微信授权处理工具
 */

import { getWeChatUserInfo } from "@/assets/js/request/api";
import { setLocalStorage, getLocalStorage } from "@/utils";
import useUsersStore from "@/stores/user";
import useRefreshStore from "@/stores/refresh";

/**
 * 处理微信授权回调
 * @param {Object} url - URL授权成功后的回调地址
 * @returns {Promise}
 */
export async function handleWechatCallback(url) {
  const urlParams = new URLSearchParams(url.split("?")[1]);
  const code = urlParams.get("code");
  const state = urlParams.get("state");
  if (!code) return;
  const savedState = getLocalStorage("wechat_auth_state"); // 验证state防止CSRF攻击
  if (state && savedState && !state.includes(savedState)) return;
  const userStore = useUsersStore();
  const refreshStore = useRefreshStore();
  if (localStorage.getItem("token")) return; // 已经登录了
  try {
    // 调用微信用户信息获取API
    const res = await getWeChatUserInfo({ code, state: savedState });
    if (res.code === 200) {
      // 保存用户信息
      setLocalStorage("token", res.token);
      userStore.setNewUserInfo(res.user);
      refreshStore.setPageRefreshData(true);
      setLocalStorage("uc_weixin_unionId_qs", res.userName);
      localStorage.setItem("uc_weixin_unionId_qs", res.userName);
      // 清除state
      localStorage.removeItem("wechat_auth_state");
      return Promise.resolve({
        success: true,
        unionid: res.userName,
        userInfo: {
          nickname: res.user.nickName,
          avatar: res.user.avatar
        }
      });
    } else {
      throw new Error("获取用户信息失败: " + (res.msg || "未知错误"));
    }
  } catch (error) {
    throw new Error("微信授权处理错误:", error);
  }
}

/**
 * 发起微信授权
 * @param {authUrl}       - 后端请求的授权地址 -获取state
 * @param {appId}         - 服务号appid
 * @param {url}           - 授权成功后的回调路由地址，并携带有code和state
 * @param {response_type} - 授权类型，固定为code
 * @param {scope}         - 授权作用域，固定为snsapi_userinfo
 */
export function initiateWechatAuth(authUrl) {
  // 提取查询参数部分 拿到state
  const queryString = authUrl.split("?")[1].split("#")[0];
  const params = new URLSearchParams(queryString);
  const state = params.get("state");
  const appid = import.meta.env.VITE_APPID;
  // const url = encodeURIComponent("https://gulingtong.cloudgn.com/app/#/vip/index");
  const url = encodeURIComponent("https://gulingtong.cloudgn.com/testApp/#/home/index");
  const response_type = "code";
  const scope = "snsapi_userinfo";
  setLocalStorage("wechat_auth_state", state);
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=${response_type}&scope=${scope}&state=${state}#wechat_redirect`;
}
